var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "text-wings",
      class: { "d-inline-flex": _vm.wings !== "both" },
    },
    [
      _vm.wings === "both" || _vm.wings === "left"
        ? _c("span", {
            staticClass: "left-wing",
            style: {
              backgroundColor: _vm.color,
              height: _vm.height + "px",
              width: _vm.width,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text",
          style: [
            _vm.wings !== "both"
              ? _vm.wings === "left"
                ? { paddingLeft: _vm.distance + "px" }
                : { paddingRight: _vm.distance + "px" }
              : {
                  paddingLeft: _vm.distance + "px",
                  paddingRight: _vm.distance + "px",
                },
          ],
        },
        [
          _vm._t("default", function () {
            return [_vm._v("PUT YOUR TITLE HERE")]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.wings === "both" || _vm.wings === "right"
        ? _c("span", {
            staticClass: "right-wing",
            style: {
              backgroundColor: _vm.color,
              height: _vm.height + "px",
              width: _vm.width,
            },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }